import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { lessonPlanner, myProjects } from "../../../../configs/WebService";
import { apiKeyHeader } from "../../../../configs/ApiKeys";

export const fetchProjectsByUserId = createAsyncThunk(
  "project/fetchByUserId",
  async (userId, thunkAPI) => {
    try {
      // const res = await axios.get(`${myProjects}/user/${userId}`);
      const res = await axios.get(
        // `http://localhost:5010/project/projects/${userId}`
        `${myProjects}/projects/${userId}`
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const createProject = createAsyncThunk(
  "project/create",
  async (payload, thunkAPI) => {
    try {
      const res = await axios.post(`${myProjects}`, payload);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateProjectById = createAsyncThunk(
  "project/update",
  async ({ id, ...data }, thunkAPI) => {
    try {
      const res = await axios.put(`${myProjects}/${id}`, data);
      // return { id, ...data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const fetchProjectsByTeacher = createAsyncThunk(
  "projects/fetchByTeacher",
  async (teacherId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${lessonPlanner}/get_projects_by_teacher/${teacherId}`,
        { headers: apiKeyHeader() }
      );
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Failed to fetch projects"
      );
    }
  }
);

export const fetchProjects = createAsyncThunk(
  "projects/fetchProjects",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${lessonPlanner}/get_all_projects`, {
        headers: apiKeyHeader(),
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch projects"
      );
    }
  }
);
export const fetchTeacherProjects = createAsyncThunk(
  "projects/fetchTeacherProjects",
  async ({ teacher_id, school_id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${lessonPlanner}/get_teacher_projects/${teacher_id}/${school_id}`,
        {
          headers: apiKeyHeader(),
        }
      );
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch teacher projects"
      );
    }
  }
);
